export default __webpack_public_path__ + "static/media/7.7b3a7b44.webp";